import { injectEpic, injectReducer } from "~/store";
import { actions, reducer, selectors } from "./zendesk.ducks";
import epics from "./zendesk.epics";
injectEpic(epics);
injectReducer("zendesk", reducer);
export { actions as zendeskActions, selectors as zendeskSelectors };
